<!-- <p-toast key="global" position="top-center"></p-toast> -->
<!-- <div [ngClass]="'scale-100'"> -->
<div class="app-shell">
  @if (navigating()) {
    <div class="nav-progress" role="progressbar" aria-label="Loading page" aria-busy="true"></div>
  }
  <p-confirmDialog appendTo="body" [baseZIndex]="3500"></p-confirmDialog>
  <p-toast key="global" position="top-center" [baseZIndex]="3200"></p-toast>
  <p-toast position="top-center" [baseZIndex]="3200"></p-toast>
  <app-global-dialog></app-global-dialog>
  <app-abandoned-session-recovery></app-abandoned-session-recovery>
  <alert></alert>
  <router-outlet></router-outlet>

  <!-- App-level AI Dialog: persists across route navigation -->
  <p-dialog
    header="Ask Notes"
    [visible]="(aiSessionState$ | async)?.isOpen || false"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '960px', maxWidth: '95vw' }"
    [blockScroll]="false"
    maskStyleClass="ai-dialog-mask"
    appendTo="body"
    [baseZIndex]="12000"
    [closeOnEscape]="true"
    (onShow)="onAiDialogShow()"
    (onHide)="closeAiDialog()">
    <app-ai></app-ai>
    <ng-template pTemplate="footer">
      <p-button label="AI Admin" icon="pi pi-microchip" severity="secondary" (onClick)="openAiAdmin()"></p-button>
      <p-button label="Close" icon="pi pi-times" (onClick)="closeAiDialog()"></p-button>
    </ng-template>
  </p-dialog>
</div>
